import { T } from "../../theme/tokens";

export function Card({ children, style, className }: { children: React.ReactNode; style?: React.CSSProperties; className?: string }) {
  // Cards that set their own inner padding get it trimmed on phones (see .card-pad in index.css).
  const padded = style?.padding !== undefined && style.padding !== 0 && style.padding !== "0";
  const classes = ["card", className, padded ? "card-pad" : ""].filter(Boolean).join(" ") || undefined;
  return (
    <div className={classes} style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "12px", ...style }}>
      {children}
    </div>
  );
}
